// src/components/CookieBanner.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Banner = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 10px;
  z-index: 1000;
`;

const AcceptButton = styled.button`
  margin-left: 10px;
  padding: 5px 10px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
`;

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    if (!cookieAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsVisible(false);
  };

  return (
    isVisible && (
      <Banner>
        This site uses cookies to improve user experience. By continuing, you accept our use of cookies.
        <AcceptButton onClick={handleAccept}>Accept</AcceptButton>
      </Banner>
    )
  );
};

export default CookieBanner;
